import { makeStyles } from '@material-ui/core/styles';

import { cardRadius, cardShadow, colors } from '../../tokens';

const useStyles = makeStyles(theme => ({
  tableCard: {
    height: 486,
    borderRadius: cardRadius,
    overflow: 'hidden',
    boxShadow: cardShadow,
    display: 'flex',
    flexDirection: 'column',
  },
  tableHeader: {
    height: 64,
    flexShrink: 0,
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 3),
    fontSize: 18,
  },
  rowsScroll: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
  },
  tableHeaderText: {
    fontSize: 18,
    color: '#fff',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  headerIcon: {
    marginRight: theme.spacing(2),
    fontSize: 24,
  },
  infoIcon: {
    marginLeft: theme.spacing(1),
    fontSize: 16,
    opacity: 0.7,
  },
  customTooltip: {
    background: '#696969',
    color: '#fff',
    fontSize: 12,
    lineHeight: 1.25,
    maxWidth: 320,
    fontWeight: 700,
  },
  tableRow: {
    display: 'grid',
    gridTemplateColumns: '1.35fr 0.65fr 1.15fr 0.85fr 34px',
    alignItems: 'center',
    minHeight: 72,
    borderBottom: `1px solid ${colors.divider}`,
    padding: theme.spacing(0, 2.5),
  },
  tableHeadRow: {
    minHeight: 52,
    flexShrink: 0,
  },
  tableCell: {
    fontSize: 15,
    color: colors.textPrimary,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  tableHeadCell: {
    color: colors.textSecondary,
    fontSize: 15,
  },
}));

export default useStyles;
